import React, { Component } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { XOKButton, XCancelButton, XInput, XSelect, XDatePicker } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import TableBox from './components/TableBox';
import model from '@/reducers/audit/list/model';
import moment from 'moment';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class AuditList extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,//路由对象
        match: PropTypes.object,
        setBreadcrumbPaths: PropTypes.func,
        getAuditList: PropTypes.func,//获取表格数据
        auditList: PropTypes.object,//表格数据
        getAuditStatus: PropTypes.func,//获取状态枚举
        auditStatus: PropTypes.array,//状态枚举
    }

    static defaultProps = {
        auditList: {
            dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0
        },
        auditStatus: []
    }

    state = {
        applicantTel: '',
        statusItem: {},
        startTime: '',
        endTime: '',
    }

    componentDidMount() {
        const { getAuditStatus, setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match);
        getAuditStatus({ enumName: 'AudiStatusEnum' });
    }

    // 查询触发
    onSearch = (useCache) => {
        const { applicantTel, statusItem, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            applicantTel,
            status: statusItem.code,
            startTime: startTime ? moment(startTime).format('YYYY-MM-DD') : undefined,
            endTime: endTime ? moment(endTime).format('YYYY-MM-DD') : undefined,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getAuditList(this.searchCache);
        KeepAlive.saveCache({ ...this.searchCache, statusItem }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    onReset = () => {
        this.setState({ startTime: '', endTime: '', applicantTel: '', statusItem: {} }, () => {
            KeepAlive.saveResetFunc(this.onSearch); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    //分页改变
    onPageChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this.onSearch('useCache');
        });
    }

    //路由页面跳转
    onPageJump = (title, url) => {
        const { history } = this.props;
        const baseUrl = '/home/audit/list';
        history.push({
            pathname: `${baseUrl}${url}`
        });
    }

    render() {
        const { auditList, auditStatus } = this.props;
        const { applicantTel, startTime, statusItem, endTime } = this.state;
        return <KeepAlive id='autonymAudit' render={(state) => {
            if (!this.state.__aliveInit) {
                this.setState({ ...state, __aliveInit: true }, () => {
                    this.onSearch('useCache'); // 【第1步：调用查询接口初始化数据】
                });
            }
        }}>
            <div className={styles.flexBoxContainer}>
                <SearchBox>
                    <SearchItem>
                        <XInput
                            label='手机号码'
                            placeholder='请输入手机号'
                            bindThis={this}
                            bindName='applicantTel'
                            value={applicantTel}
                            showLength={false}
                            maxLength={20}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='状态'
                            placeholder='请选择状态'
                            renderData={auditStatus}
                            bindThis={this}
                            bindName='statusItem'
                            dataIndex='value'
                            keyIndex='code'
                            value={statusItem.value}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XDatePicker
                            label='申请日期'
                            placeholder='请选择开始时间'
                            value={startTime}
                            bindThis={this}
                            bindName='startTime'
                            showTime={false}
                            disabledDate={current => {
                                if (current && endTime && current > endTime) {
                                    return true;
                                }
                            }}
                        />
                        <XDatePicker
                            style={{ marginRight: '20px' }}
                            placeholder='请选择结束时间'
                            value={endTime}
                            bindThis={this}
                            bindName='endTime'
                            showTime={false}
                            disabledDate={current => {
                                if (current && startTime && current < startTime) {
                                    return true;
                                }
                            }}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={this.onSearch}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={this.onReset}
                        />
                    </SearchItem>
                </SearchBox>
                {/* <XOKButton
                    style={{ width: '100px' }}
                    label='生成报表'
                    onClick={() => { alert('待联调') }}
                /> */}
                <TableBox
                    tableData={auditList}
                    onPageJump={this.onPageJump}
                    onPageChange={this.onPageChange}
                />
            </div>
        </KeepAlive>;
    }
}

export default connect(state => ({
    auditList: state.auditList.auditList,
    auditStatus: state.auditList.auditStatus,
}), {
    ...model.actions,
    setBreadcrumbPaths
})(AuditList);